<template>
  <div class="search">
    <img
      class="exit"
      src="/images/icons/close-btn.svg"
      alt=""
      @click="onCloseSearch"
    />
    <div class="content-max-width search-menu">
      <h1>Search</h1>
      <div class="form-field flex align-center">
        <input type="text" v-model="payload.keyword" placeholder="Search" @keyup.enter="enterButton">
        <button class="search-icon" @click="search">
          <img src="/images/icons/magnify-white.svg" alt="" />
        </button>
      </div>
      <div class="popular-search">
        <p>{{searches.label}}</p>
        <div class="tags">
            <div v-for="item in searches.items" class="list">
                <a :href="item.url"  :key="item.id">
                    {{ item.title }}
                </a>
            </div>

          <!-- <div class="list">
            <a href="#">Epicurus in</a>
            <a href="#">Ut placet inquam</a>
            <a href="#">Laudem et aperta iudic</a>
            <a href="#">Tum dicere</a>
          </div>
          <div class="list">
            <a href="#">In quo aut</a>
            <a href="#">Et quidem rerum</a>
            <a href="#">Torquatos nostros</a>
            <a href="#">In oculis</a>
          </div>
          <div class="list">
            <a href="#">Ut placet inquam tum</a>
            <a href="#">Quae fuerit</a>
            <a href="#">Filium morte multavit</a>
            <a href="#">Sed</a>
          </div> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    searches: Object
  },
  data () {
    return {
      payload: {
        keyword: '',
      }
    }
  },
  mounted () {
    console.log('search menu', this.searches)
  },
  methods: {
    onCloseSearch() {
      this.$emit("onCloseSearch");
    },

    enterButton () {
        this.search()
      },

      search () {

        window.location.href = '/search?keyword=' + this.payload.keyword
      }
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// resources/assets/frontend/js/components/SearchMenu.vue